/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { useEffect } from "react";
import FabCss from "components/FAB/FAB.css";
import PropTypes from "prop-types";
import { discovery } from "dc-core";
import { CSSTransition } from "react-transition-group";

const FABView = props => {
  const { FABVerbId, FABVisibility, bottomOffset, FABComponent, setFABVisibility } = props;

  useEffect(() => {
    if (FABVerbId) {
      const opts = { context: "FAB", showCallback: setFABVisibility };
      discovery.callBootstrapMethod(FABVerbId, "initializeAction", opts);
    }
  }, [FABVerbId]);

  return (
    <CSSTransition
      in={!!FABComponent && FABVisibility}
      timeout={{
        enter: 100,
        exit: 500
      }}
      classNames={{
        enter: FabCss.fabEnter,
        enterActive: FabCss.fabEnterActive,
        enterDone: FabCss.fabEnterDone,
        exitActive: FabCss.fabExitActive,
        exitDone: FabCss.fabExitDone
      }}
      mountOnEnter
      unmountOnExit
    >
      <div className={FabCss.fabContainer} style={{ bottom: bottomOffset }} data-testid="fab" id="fab-container">
        <FABComponent />
      </div>
    </CSSTransition>
  );
};

FABView.propTypes = {
  FABVerbId: PropTypes.string,
  FABVisibility: PropTypes.bool
};

FABView.defaultProps = {
  FABVerbId: "",
  FABVisibility: false
};

export default FABView;
